(function () {
  if (window.__etaNoteInit) return;         // prevent double init
  window.__etaNoteInit = true;

  function init(root) {
    if (!root) return;
    const etaRaw = (root.getAttribute('data-eta') || '').trim();
    const noteEl = root.querySelector('.eta-note__text');
    if (!noteEl) return;

    if (etaRaw) {
      // You can tweak this format if needed
      noteEl.textContent = `ETA: ${etaRaw}`;
      noteEl.classList.remove('hidden');
    } else {
      // No ETA -> keep it hidden or remove entirely
      root.remove();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-eta-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
